import {Box, Stack, Typography, useMediaQuery} from "@mui/material";
import HeaderButton from "./HeaderButton";
import ROUTE from "../../constants/route";
import {useLocation} from "react-router-dom";
import BackToMainPage from "./BackToMainPage";
import {styled} from "@mui/material/styles";
import MainLogo from "components/MainLogo";

const BUTTONS = [
  {
    path: `/${ROUTE.QUESTIONS}`,
    text: 'Найдите ответ'
  },
  // {
  //   path: `/${ROUTE.KNOWLEDGE_BASE}`,
  //   text: 'База знаний'
  // },
  {
    path: `/${ROUTE.MATERIAL}`,
    text: 'Полезные материалы'
  },
]

const StyledHeader = styled(Box)(({theme}) => ({
  margin: theme.spacing(1.2),
  borderRadius: 12,
  backgroundColor: theme.palette.primary.main,
  padding: theme.spacing(5),
  [theme.breakpoints.up('xxs')]: {
    padding: theme.spacing(3, 2),
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(4, 2.5),
  },
  [theme.breakpoints.up('xl')]: {
    padding: theme.spacing(5),
  },
}));

const StyledTitle = styled(Typography)(({theme}) => ({
  textTransform: 'uppercase',
  color: '#fff',
  [theme.breakpoints.up('xxs')]: {
    fontSize: 20,
  },
  [theme.breakpoints.up('xs')]: {
    fontSize: 24,
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: 28,
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: 60,
  },
  [theme.breakpoints.up('md')]: {
    fontSize: 48,
  },
}));

const NavButtons = () => {
  return (
    <Stack direction={{xxs: 'column', md: 'row'}} spacing={{xxs: 1, lg: 3}} flex={2}>
      {
        BUTTONS.map((button, index) => (
          <HeaderButton key={`nav-button-${index}`} text={button.text} path={button.path}/>
        ))
      }
    </Stack>
  )
}

const Header = () => {
  const location = useLocation();
  const currentTitle = BUTTONS.find(button => location.pathname.includes(button.path))?.text;
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('lg'));

  return (
    <StyledHeader>
      {
        isDesktop
          ? (
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              mb: 3
            }}>
              <MainLogo iconProps={{sx: {color: '#fff', width: 48, height: 88, mr: 6}}}/>
              <NavButtons/>
              <Box flex={0.2} display={{xs: 'none', lg: 'flex'}}/>
              <BackToMainPage/>
            </Box>
          )
          : (
            <Stack mb={2.5}>
              <Stack direction={'row'} justifyContent={'space-between'} mb={2.5}>
                <MainLogo iconProps={{sx: {color: '#fff', width: 35, height: 64}}}/>
                <BackToMainPage/>
              </Stack>
              <NavButtons/>
            </Stack>
          )
      }
      <StyledTitle variant={'h1'}>
        {currentTitle}
      </StyledTitle>
    </StyledHeader>
  )
}

export default Header
